"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatVariantLabel = void 0;
/**
 * Renders variant options as a human label.
 * e.g. [{ name: 'Size', value: 'M' }, { name: 'Color', value: 'Navy' }]
 *   -> "Size: M / Color: Navy"
 * Preserves order and renders names as stored (no capitalization changes).
 * Returns "" for null or empty options.
 */
const formatVariantLabel = (options) => {
    if (!options || options.length === 0) {
        return '';
    }
    return options.map((option) => `${option.name}: ${option.value}`).join(' / ');
};
exports.formatVariantLabel = formatVariantLabel;
